import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MeterValidationRegionData } from '../../../../models/meter-validation.model';

@Component({
  selector: 'lib-meter-validation-card',
  templateUrl: './meter-validation-card.component.html',
  styleUrl: './meter-validation-card.component.scss',
  standalone: false,
})
export class MeterValidationCardComponent implements OnInit {
  @Input() title!: string;
  @Input() number!: number;
  @Input() iconKey!: string;
  @Input() lastMonthCount?: number;
  @Input() percentage?: number;
  @Input() useDetails: boolean = false;
  @Input() seeBreakdownVisible: boolean = false;
  @Input() isPercentageNumber: boolean = false;
  @Input() meterValidationRegionData!: MeterValidationRegionData;

  @Output() detailsClicked = new EventEmitter<
    MeterValidationRegionData | undefined
  >();
  unvalidatedCount: number = 0;

  ngOnInit(): void {
    this.unvalidatedCount = this.meterValidationRegionData
      ? this.meterValidationRegionData.totalCount -
        this.meterValidationRegionData.validatedCount
      : 0;
  }
}
